import { WithWorkspaceId } from '~/types/common';
import { WorkspaceKey } from '~/types/resources';
import { integrationWorkspaceKeyApi } from '~/utils/api';

export const getWorkspaceKeys = async ({ workspaceId }: WithWorkspaceId) =>
  integrationWorkspaceKeyApi.get(`/workspaces/${workspaceId}/accessKeys`);

export const deleteWorkspaceKeys = async ({ workspaceId }: WithWorkspaceId) =>
  integrationWorkspaceKeyApi.delete(`/workspaces/${workspaceId}/accessKeys`);

export const createWorkspaceKey = async ({
  workspaceId,
  params,
}: { params: Partial<WorkspaceKey> } & WithWorkspaceId) =>
  integrationWorkspaceKeyApi.post(`/workspaces/${workspaceId}/accessKeys`, params);

export const deleteWorkspaceKey = async ({
  workspaceId,
  keyId,
}: { keyId: string } & WithWorkspaceId) =>
  integrationWorkspaceKeyApi.delete(`/workspaces/${workspaceId}/accessKeys/${keyId}`);

export const getWorkspaceKey = async ({
  workspaceId,
  keyId,
}: { keyId: string } & WithWorkspaceId) =>
  integrationWorkspaceKeyApi.get(`/workspaces/${workspaceId}/accessKeys/${keyId}`);

export const editWorkspaceKey = async ({
  workspaceId,
  keyId,
  params,
}: { keyId: string; params: Partial<WorkspaceKey> } & WithWorkspaceId) =>
  integrationWorkspaceKeyApi.put(`/workspaces/${workspaceId}/accessKeys/${keyId}`, { ...params });
